<template>
    <div>
        <div class="title-operation" v-show="viewPart == 'list'">
            <div>
                <el-button v-if="showReturnBtn === true" @click="clickReturnBtn" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>&nbsp;
            </div>

            <div>
                <el-button type="primary" @click="goAdd" tkey="添加產品單位">{{i18n.tkey("lang_add_product_unit")}}</el-button>
            </div>
        </div>

        <div class="title-operation" v-show="viewPart == 'edit'">
            <div>
                <el-button @click="returnList" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <div>
                &nbsp;
            </div>
        </div>

        <unitCodeList v-if="viewPart == 'list'" @clickEditBtn="goEdit" />

        <insertOrEditUnitCode v-if="viewPart == 'edit'" :editObj="editObj" @save-complete="saveCallback" />
    </div>
</template>

<script setup>
    import unitCodeList from "@/components/shopopee/unit/unitCodeList"
    import insertOrEditUnitCode from "@/components/shopopee/unit/insertOrEditUnitCode"
    import {inject, ref} from "vue";

    const props = defineProps(["showReturnBtn"])
    const emits = defineEmits(["clickReturnBtn"])

    const i18n = inject("i18n")

    const viewPart = ref("list")
    const editObj = ref(null)

    function saveCallback() {
        viewPart.value = "list"
        editObj.value = null
    }

    function returnList() {
        viewPart.value = "list"
        editObj.value = null
    }

    function goAdd() {
        viewPart.value = "edit"
    }

    function goEdit(obj) {
        editObj.value = obj
        viewPart.value = "edit"
    }

    function clickReturnBtn() {
        emits("clickReturnBtn")
    }

</script>

<style scoped>
    .title-operation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }
</style>